import { Webhook } from '../../domain/webhook/Webhook';

export enum WebhookActionType {
  FETCH_WEBHOOKS_SUCCESS = `FETCH_WEBHOOKS_SUCCESS`,
  DELETE_WEBHOOK_SUCCESS = `DELETE_WEBHOOK_SUCCESS`,
  UPDATE_WEBHOOK_SUCCESS = `UPDATE_WEBHOOK_SUCCESS`,
}

export interface FetchWebhooksSuccessAction {
  type: WebhookActionType.FETCH_WEBHOOKS_SUCCESS;
  payload: {
    webhooks: Webhook[];
  };
}

export interface UpdateWebhookSuccessAction {
  type: WebhookActionType.UPDATE_WEBHOOK_SUCCESS;
  payload: {
    webhooks: Webhook[];
  };
}

export interface DeleteWebhookSuccessAction {
  type: WebhookActionType.DELETE_WEBHOOK_SUCCESS;
  payload: {
    webhook: Webhook;
  };
}

export type WebhookActions = FetchWebhooksSuccessAction | UpdateWebhookSuccessAction | DeleteWebhookSuccessAction;
